import type { RootState } from '@/redux/RootReducer';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';
import type { FC } from 'react';
import { useSelector } from 'react-redux';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentCategory } from '../../hooks';

interface ShipmentCategorySelectProps
  extends Pick<FormItemProps, 'rules' | 'name' | 'colon'>,
    Pick<SelectProps, 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  singleLineMode?: boolean;
  inverMode?: boolean;
  onChange: (value?: unknown) => void;
  categoryId?: string;
}

export const ShipmentCategorySelect: FC<ShipmentCategorySelectProps> = ({
  placeholder = i18n.t('translation:default.fields.category.placeholder'),
  label = i18n.t('translation:default.fields.category.label'),
  rules = [],
  name,
  editMode,
  margin,
  singleLineMode,
  inverMode,
  colon,
  onChange,
  categoryId,
}) => {
  const { selectedCompany } = useSelector((state: RootState) => state.auth);

  const { data = [], isLoading } = useGetShipmentCategory({
    CustomerKey: selectedCompany.companyId,
    CategoryId: categoryId as string,
  });

  return (
    <FormSelectBox
      loading={isLoading}
      options={data}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      singleLineMode={singleLineMode}
      inverMode={inverMode}
      colon={colon}
      onChange={onChange}
    />
  );
};
